import { observer } from 'mobx-react';
import React, { FC, useState } from 'react';
import { DragDropContext, Droppable, DropResult } from 'react-beautiful-dnd';
import ResponseEntity from '../../../store/polls-store/response-entity';
import PollResponseDraggable from './poll-response-draggable';
import { NonceCSP } from '../../../constans/common-constants';

interface IProps {
  responseList: ResponseEntity[];
  setResponses: (responses: ResponseEntity[]) => void;
  deleteResponseById: (deleteId: string) => void;
  validation: (isValid: boolean) => void;
}

const PollResponseList: FC<IProps> = ({ responseList, setResponses, deleteResponseById, validation }) => {
  const [invalidResponses, setInvalidResponses] = useState<string[]>([]);

  const reorderResponseList = (startIndex: number, endIndex: number) => {
    const result = responseList;
    const removedItemsNumber = 1;
    const [removed] = result.splice(startIndex, removedItemsNumber);
    result.splice(endIndex, 0, removed);

    return result.map((el: ResponseEntity, index: number) => {
      el.order = index;
      return el;
    });
  };

  const onDragEndHandler = (result: DropResult): void => {
    const { source, destination } = result;
    if (destination && result.destination?.index !== result.source.index) {
      const reorderedResponseList = reorderResponseList(source.index, destination.index);
      setResponses(reorderedResponseList);
    }
  };

  const deleteResponse = (id: string) => {
    const updatedInvalidResponses = invalidResponses.filter(item => item !== id);

    deleteResponseById(id);
    setInvalidResponses(updatedInvalidResponses);
    validation(!updatedInvalidResponses.length);
  };

  const defineInvalidResponse = (isValid: boolean, response: ResponseEntity) => {
    const updatedInvalidResponses = isValid
      ? invalidResponses.concat(response.pollChoiceId)
      : invalidResponses.filter(item => item !== response.pollChoiceId);

    setInvalidResponses(updatedInvalidResponses);
    validation(!updatedInvalidResponses.length);
  };

  return (
    <>
      <DragDropContext onDragEnd={onDragEndHandler} nonce={NonceCSP.DND}>
        <Droppable droppableId='response-items'>
          {(provided) => (
            <div className='manage-poll-responses-list-draggable' ref={provided.innerRef} {...provided.droppableProps}>
              {responseList.length
                ? responseList.map((item, index) => (
                  <PollResponseDraggable
                    key={item.pollChoiceId}
                    response={item}
                    index={index}
                    deleteResponseById={deleteResponse}
                    validation={(isValid) => defineInvalidResponse(isValid, item)}
                  />
                ))
                : null
              }
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </>
  );
};

export default observer(PollResponseList);
